import { render, staticRenderFns } from "./TabCreator.vue?vue&type=template&id=fc0454ba&scoped=true&"
import script from "./TabCreator.vue?vue&type=script&lang=ts&"
export * from "./TabCreator.vue?vue&type=script&lang=ts&"
import style0 from "./TabCreator.vue?vue&type=style&index=0&id=fc0454ba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc0454ba",
  null
  
)

export default component.exports